import React from 'react';
import { Badge } from 'react-bootstrap';
import { PromotionStatus } from '../../types/PromotionTypes';
import {
  PROMOTION_STATUS_LABELS,
  PROMOTION_STATUS_VARIANTS,
} from '../../utils/promotionUtils';
import styles from './PromotionStatusBadge.module.scss';

interface PromotionStatusBadgeProps {
  status: PromotionStatus;
}

export function PromotionStatusBadge(props: PromotionStatusBadgeProps) {
  const { status } = props;

  if (status === 'disabled') {
    return (
      <Badge className={styles.disabled}>
        {PROMOTION_STATUS_LABELS[status]}
      </Badge>
    );
  }

  return (
    <Badge variant={PROMOTION_STATUS_VARIANTS[status]}>
      {PROMOTION_STATUS_LABELS[status]}
    </Badge>
  );
}
